<template>
      <el-form-item :label="label" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
</template>


<script>
export default {
    name:'time',
    data(){
        return{
            form:{
            end_time:'',
            start_time:''
        }
        }
    },
    props: {
      label: String,
          form:{
            end_time:'',
            start_time:''
        }
 
    }
}
</script>
